import { jsx as _jsx } from "react/jsx-runtime";
import { c } from 'ttag';
const ProtectedUnauthorizedLabel = () => {
    return (_jsx("div", { className: "text-center", children: c('B2.NavSharedUI.Info').t `This item is protected. Please authorize first.` }));
};
export default ProtectedUnauthorizedLabel;
